import React, {createContext, ReactNode, useContext, useReducer} from 'react';
import {reducer, initialState} from 'features/POSRegisters/reducers/posReducer';
import POSState from 'features/POSRegisters/interfaces/POSState';
export {actionTypes as posActionTypes} from 'features/POSRegisters/reducers/posReducer';

type POSStateContext = {state: POSState; dispatch: React.Dispatch<any>};

const POSStateContext = createContext<POSStateContext>({} as POSStateContext);

export default function POSStateProvider({children}: {children: ReactNode}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <POSStateContext.Provider value={{state, dispatch}}>{children}</POSStateContext.Provider>;
}

export const usePOSState = () => {
  const context = useContext(POSStateContext);

  if (context === undefined) {
    throw new Error('usePOState must be within POSStateProvider');
  }

  return context;
};
